export const scoreAnalysisTemplate = {
  type:"text-input",
  config:{
    number:"14",points:8.5,variant:"score-analysis",
    prompt:"The Sonata-Allegro Form consists of three principal parts. Complete the blanks below, then use the score to analyze the first movement.",
    scoreTitle:"Clementi — Sonatina Op. 36, No. 4, first movement",
    scorePdfUrl:"",
    principalParts:[
      {id:"I",label:"I.",points:0.5,correct:["Exposition"]},
      {id:"II",label:"II.",points:0.5,correct:["Development"]},
      {id:"III",label:"III.",points:0.5,correct:["Recapitulation"]}
    ],
    themeNames:[
      {id:"A",label:"A.",points:1,correct:["Primary","Principal","First","Main"]},
      {id:"B",label:"B.",points:1,correct:["Secondary","Subordinate","Second"]}
    ],
    sectionRows:[
      {id:"IA",label:"I A",hasKey:true,points:1,measureAnswers:[],keyAnswers:[]},
      {id:"IB",label:"I B",hasKey:true,points:1,measureAnswers:[],keyAnswers:[]},
      {id:"II",label:"II",hasKey:false,points:1,measureAnswers:[]},
      {id:"IIIA",label:"III A",hasKey:true,points:1,measureAnswers:[],keyAnswers:[]},
      {id:"IIIB",label:"III B",hasKey:true,points:1,measureAnswers:[],keyAnswers:[]}
    ]
  }
};

export function updateScoreAnalysisAnswer(value,group,id,text,field) {
  const saved=value&&typeof value==='object'&&!Array.isArray(value)?value:{};
  return {...saved,[group]:{...saved[group],
    [id]:field?{...saved[group]?.[id],[field]:text}:text}};
}
export function scoreAnalysisTotal(config) {
  return ['principalParts','themeNames','sectionRows'].reduce((sum,group)=>sum+(config[group] || []).reduce((s,row)=>s+Math.max(0,Number(row.points)||0),0),0);
}
export function answerAlternatives(value) {
  return (Array.isArray(value)?value:[value]).filter(v=>v!=null&&String(v).trim()!=='');
}
export function scoreAnalysisIssues(config) {
  const issues=[];
  if(!String(config.scorePdfUrl || '').trim())issues.push('Upload the score PDF or enter its URL.');
  const ids=new Set();
  for(const [group,rows] of [['principalParts',config.principalParts],['themeNames',config.themeNames],['sectionRows',config.sectionRows]]) {
    if(!Array.isArray(rows)||!rows.length)issues.push(`Add ${group} fields.`);
    for(const row of rows || []) {
      const token=`${group}.${row.id}`;
      if(!row.id||ids.has(token))issues.push('Every answer field needs a unique ID.');
      ids.add(token);
      if(!Number.isFinite(Number(row.points))||Number(row.points)<0)issues.push(`Enter valid points for ${row.label || row.id}.`);
      if(group==='sectionRows') {
        if(!answerAlternatives(row.measureAnswers).some(v=>/^\d+$/.test(String(v).trim())&&Number(v)>0))issues.push(`Enter the starting measure for ${row.label}.`);
        if(row.hasKey&&!answerAlternatives(row.keyAnswers).length)issues.push(`Enter the key for ${row.label}.`);
      }else if(!answerAlternatives(row.correct).length)issues.push(`Enter the answer for ${row.label || row.id}.`);
    }
  }
  if(Math.abs(scoreAnalysisTotal(config)-(Number(config.points)||0))>1e-7)issues.push('Field points must add up to the question total.');
  return issues;
}
